$.fn.grantSections = function () {
  function isInGrantSectionsPage() {
    return $("#grant-sections-page").length > 0;
  }
  function isInGrantCodePage() {
    return $("#grant-code-page").length > 0;
  }

  if (isInGrantCodePage()) {
    if ($("#hiddenUserGroup").length) {
      var userGroup = $("#hiddenUserGroup").val();
      $("#hiddenUserGroup").val("");
      if (userGroup.charAt(0) === ",") {
        userGroup = userGroup.substring(1);
      }
      if (
        userGroup != "" &&
        !($("#accessGroup option[value=" + userGroup + "]").length > 0)
      ) {
        $("#grantAccessName").text(userGroup);
        $("#grantAccessName").val(userGroup);
        $("#accessGroup").val(userGroup);
        $("#accessGroup").trigger("chosen:updated");
      }
    }

    if ($("#grant").val() != "" || $("#grant").val() != null) {
      $("#grant_name").on("change", function () {
        var hyphenatedName = $(this)
          .val()
          .trim()
          .toLowerCase()
          .replaceAll(" ", "-");
        $("#grantAccessName").text(hyphenatedName);
        $("#grantAccessName").val(hyphenatedName);
        $("#accessGroup").val(hyphenatedName);
        $("#accessGroup").trigger("chosen:updated");
      });
    }

    $("#grant_code").keyup(function () {
      var grantCode = $(this).val().toLowerCase().replace(/ /g, "-");
      $(this).val(grantCode);
    });
  }

  if (isInGrantSectionsPage()) {
    $("#section_code").keyup(function () {
      var grantSectionCode = $(this).val().toLowerCase().replace(/ /g, "-");
      $(this).val(grantSectionCode);
    });
    $("#payment_day").keyup(function () {
      if ($("#nettableYes").is(":checked")) {
        var paymentDay = $(this).val();
        $("#receipt_day").val(paymentDay);
      }
    });
    $("#receipt_day").keyup(function () {
      if ($("#nettableYes").is(":checked")) {
        var receiptDay = $(this).val();
        $("#payment_day").val(receiptDay);
      }
    });

    $("#nettableYes").click(function () {
      $("#payment_day").val(15);
      $("#receipt_day").val(15);
    });
    $("#nettableNo").click(function () {
      $("#payment_day").val(15);
      $("#receipt_day").val(22);
    });

    $("#nettableNo").trigger("click");

    /*var select, chosen;

    // Cache the select element as we'll be using it a few times
    select = $("#accessGroup");

    // Init the chosen plugin
    select.chosen({ no_results_text: 'Press Enter to add new entry:' });

    // Get the chosen object
    chosen = select.data('chosen');

    // Bind the keyup event to the search box input
    chosen.dropdown.find('input').on('keyup', function(e)
    {
        var grantName = $('#grant_name').val().replaceAll(" ", "-");
        var $elements = $('#accessGroup_chosen .chosen-drop').find('.chosen-results')
        var $grantList = $('<li class="create-option active-result grant-chosen"><a>Add grant name</a>": "' + grantName +'""</li>');
        $grantList.find('a').on('click', grantAppend);
        $elements.append($grantList);

        $('.grant-chosen a').click(function() {
        })
        $('.grant-chosen').on('DOMSubtreeModified',function() {

        })

        function grantAppend() {
        }
        // If we hit Enter and the results list is empty (no matches) add the option
//        if (e.which === 13 && chosen.dropdown.find('li.no-results').length > 0)
//        {
//            var option = $("<option>").val(grantName).text(grantName);
//
//            // Add the new option
//            select.prepend(option);
//            // Automatically select it
//            select.find(option).prop('selected', true);
//            // Trigger the update
//            select.trigger("chosen:updated");
//        }
    });*/
  }
};
